import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDiscoveryRequestTask } from "../../contexts/DiscoveryRequestTaskContext";
import {
  DescriptionDetails,
  DescriptionList,
  DescriptionTerm,
} from "../../design/description-list";
import { Heading, Subheading } from "../../design/heading";
import { Divider } from "../../design/divider";
import DeleteDiscoveryRequestTaskButton from "./components/DeleteDiscoveryRequestTaskButton";
import LoadingView from "../../components/LoadingView";
import EditDiscoveryRequestTaskButton from "./components/EditDiscoveryRequestTaskButton";
import DiscoveryRequestTaskFilesList from "./components/Files/DiscoveryRequestTaskFilesList";
import { useSeenState } from "../../contexts/SeenStateContext";
import ErrorView from "../../components/ErrorView";
import Breadcrumbs from "../../components/Breadcrumbs";
import CompleteDiscoveryRequestTaskButton from "./components/CompleteDiscoveryRequestTaskButton";

const DiscoveryRequestTaskDetailPage: React.FC = () => {
  const { recordSeenState } = useSeenState();
  const { discoveryRequestTaskId } = useParams<{
    discoveryRequestTaskId: string;
  }>();
  const {
    selectedDiscoveryRequestTask,
    selectDiscoveryRequestTaskById,
    error,
    loading,
  } = useDiscoveryRequestTask();
  const [isCompleteOpen, setIsCompleteOpen] = useState(false);

  useEffect(() => {
    if (discoveryRequestTaskId) {
      selectDiscoveryRequestTaskById(discoveryRequestTaskId);
      recordSeenState({ discoveryRequestTaskId });
    }
  }, [discoveryRequestTaskId]);

  if (loading.details) {
    return <LoadingView title="Loading Discovery Request Task" />;
  }

  if (error.details) {
    return <ErrorView error={error.details} />;
  }

  if (!selectedDiscoveryRequestTask) {
    return <ErrorView error={new Error("DiscoveryRequestTask not found")} />;
  }

  return (
    <div>
      <Breadcrumbs
        items={[
          { label: "DiscoveryRequestTasks", href: "/discovery-requests" },
          {
            label: selectedDiscoveryRequestTask.discoveryRequestId,
            href: `/discovery-request/${selectedDiscoveryRequestTask.discoveryRequestId}`,
          },
          {
            label: selectedDiscoveryRequestTask._id,
            href: `/discovery-request-task/${selectedDiscoveryRequestTask._id}`,
          },
        ]}
      />

      <div className="flex flex-col gap-6 lg:flex-row">
        <div className="flex flex-col w-full gap-6">
          <div className="mb-6">
            <div className="flex items-center justify-between">
              <Heading>Discovery Request Task Detail</Heading>
              <div className="flex gap-2">
                <EditDiscoveryRequestTaskButton
                  discoveryRequestTask={selectedDiscoveryRequestTask}
                />
                <DeleteDiscoveryRequestTaskButton
                  discoveryRequestTaskId={selectedDiscoveryRequestTask._id}
                />
              </div>
            </div>
          </div>
          <Divider className="mt-2" />
          <DescriptionList></DescriptionList>

          <Subheading>Supporting Files</Subheading>
          <CompleteDiscoveryRequestTaskButton
            isOpen={isCompleteOpen}
            setIsOpen={setIsCompleteOpen}
            discoveryRequestTaskId={selectedDiscoveryRequestTask._id}
          />
          <DiscoveryRequestTaskFilesList
            taskId={selectedDiscoveryRequestTask._id}
            onFileForDiscoveryRequestTaskUploaded={() =>
              setIsCompleteOpen(true)
            }
          />
        </div>
      </div>
    </div>
  );
};

export default DiscoveryRequestTaskDetailPage;
